import { Pipe, PipeTransform, SecurityContext, VERSION } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'AONl2br'
})
export class AONl2BrPipe implements PipeTransform {

  constructor(
    private _sanitizer: DomSanitizer
  ) {
  }

  transform(value: string, sanitizeBeforehand?: boolean): string | SafeHtml {
    const parsed = value.replace(/(?:\r\n|\r|\n)/g, '<br />');

    if (!VERSION || VERSION.major === '2') {
      return this._sanitizer.bypassSecurityTrustHtml(parsed);
    } else if (sanitizeBeforehand) {
      return this._sanitizer.sanitize(SecurityContext.HTML, parsed);
    }

    return parsed;
  }

}
